import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/**
 * Returns true only when the component has mounted on the client AND the
 * Next.js router is ready. Use this in _app to gate page rendering so that:
 * 1. SSR hydration mismatches are avoided (replaces the skipSSG pattern)
 * 2. Route params are available before any page component mounts
 */
export function useClientReady(): boolean {
  const { isReady } = useRouter();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted && isReady;
}
